var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Menu, alpha, IconButton, MenuItem, styled, } from '@mui/material';
var StyledMenu = styled(function (props) { return (_jsx(Menu, __assign({ elevation: 0, anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    }, transformOrigin: {
        vertical: 'top',
        horizontal: 'right',
    } }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiPaper-root': {
            borderRadius: 6,
            marginTop: theme.spacing(1),
            minWidth: 180,
            color: theme.palette.mode === 'light'
                ? 'rgb(55, 65, 81)'
                : theme.palette.grey[300],
            boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            '& .MuiMenu-list': {
                padding: '4px 0',
            },
            '& .MuiMenuItem-root': {
                '& .MuiSvgIcon-root': {
                    fontSize: 18,
                    color: theme.palette.text.secondary,
                    marginRight: theme.spacing(1.5),
                },
                '&:active': {
                    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                },
            },
        },
    });
});
var MenuDropdownItem = function (_a) {
    var ele = _a.ele, onClick = _a.onClick;
    var IconRender = useMemo(function () {
        return styled(ele.icon)({
            top: '4px',
            left: '3px',
        });
    }, [ele.icon]);
    var handleClick = function () {
        onClick(ele);
    };
    return (_jsxs(MenuItem, { id: ele.id, onClick: handleClick, disableRipple: true, children: [_jsx(IconRender, {}), ele.label] }, ele.id));
};
export var DropDownButton = function (_a) {
    var menu = _a.menu;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
        var menu = document.getElementById('demo-customized-menu');
        if (menu) {
            menu.style.visibility = 'initial';
        }
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleSelectMenu = function (ele) {
        ele.onClick();
        setAnchorEl(null);
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { id: "demo-customized-button", "aria-controls": open ? 'demo-customized-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick, sx: { width: 24, height: 24 }, children: _jsx(KeyboardArrowDownIcon, {}) }), _jsx(StyledMenu, { id: "demo-customized-menu", MenuListProps: {
                    'aria-labelledby': 'demo-customized-button',
                }, anchorEl: anchorEl, open: open, onClose: handleClose, sx: {
                    bgcolor: 'red',
                }, children: menu.map(function (ele) {
                    return (_jsx(MenuDropdownItem, { ele: ele, onClick: handleSelectMenu }, ele.id));
                }) })] }));
};
